<div class="trustee-logo">
  <img [src]="'assets/trustee/'+(key$ | async)+'/logo.Xx128.png'"
       *ngIf="hasLogo$ | async"
       onerror="this.style.display='none'">
  <!-- TODO: fallback image -->
  <div class="label" *ngIf="showFallbackLabel && !(hasLogo$ | async)">
    {{ label$ | async }}
  </div>
</div>
